import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function ResetPasswordPage({ onBack, go }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const resetToken = params.get("token") || "";

  const submitReset = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!resetToken) {
      setError("This password reset link is invalid or incomplete.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setSubmitting(true);

    try {
      const r = await api.post("/auth/reset-password", {
        token: resetToken,
        password,
      });

      setMessage(
        r.data?.message || "Your password has been reset successfully."
      );
      setPassword("");
      setConfirmPassword("");
    } catch (err) {
      const detail = err.response?.data?.detail;

      if (typeof detail === "string") {
        setError(detail);
      } else if (Array.isArray(detail)) {
        setError(
          detail
            .map((item) => item?.msg || "Invalid password reset request.")
            .join(" ")
        );
      } else if (detail && typeof detail === "object") {
        setError(detail.msg || "Unable to reset your password.");
      } else {
        setError(
          "Unable to reset your password. The link may have expired."
        );
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-card">
        <button
          type="button"
          className="reset-back"
          onClick={onBack}
          aria-label="Go back"
        >
          <ArrowLeft size={18} />
          <span>Back</span>
        </button>

        {message ? (
          <div className="reset-success">
            <div className="reset-icon success">
              <CheckCircle2 size={30} />
            </div>

            <span className="eyebrow">ACCOUNT SECURED</span>

            <h1>Password Reset Complete</h1>

            <p>
              Your password has been changed successfully. You can now sign
              in to your Vijayanagar Civic Portal account using your new
              password.
            </p>

            <button
              type="button"
              className="civic-btn primary full reset-action"
              onClick={() => go("/")}
            >
              Return to Resident Login
            </button>
          </div>
        ) : (
          <>
            <div className="reset-header">
              <div className="reset-icon">
                <LockKeyhole size={30} />
              </div>

              <span className="eyebrow">ACCOUNT SECURITY</span>

              <h1>Create a New Password</h1>

              <p>
                Choose a strong new password to secure your civic portal
                account.
              </p>
            </div>

            <form className="reset-form" onSubmit={submitReset}>
              <label>
                New Password
                <div className="reset-password-field">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength="8"
                    autoComplete="new-password"
                    placeholder="Enter your new password"
                    required
                  />

                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </label>

              <label>
                Confirm New Password
                <div className="reset-password-field">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    minLength="8"
                    autoComplete="new-password"
                    placeholder="Re-enter your new password"
                    required
                  />

                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword((v) => !v)}
                    aria-label={
                      showConfirmPassword
                        ? "Hide password"
                        : "Show password"
                    }
                  >
                    {showConfirmPassword ? (
                      <EyeOff size={18} />
                    ) : (
                      <Eye size={18} />
                    )}
                  </button>
                </div>
              </label>

              <div className="reset-requirements">
                <div className={password.length >= 8 ? "valid" : ""}>
                  <Check size={15} />
                  At least 8 characters
                </div>

                <div
                  className={
                    password &&
                    confirmPassword &&
                    password === confirmPassword
                      ? "valid"
                      : ""
                  }
                >
                  <Check size={15} />
                  Passwords match
                </div>
              </div>

              {error && (
                <div className="reset-error" role="alert">
                  <AlertCircle size={18} />
                  <span>{error}</span>
                </div>
              )}

              <button
                type="submit"
                className="civic-btn primary full reset-action"
                disabled={submitting}
              >
                {submitting ? "Updating Password..." : "Reset Password"}
              </button>

              <p className="reset-security-note">
                <ShieldCheck size={16} />
                Your password reset link is temporary and can only be used
                once.
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}


export default ResetPasswordPage;
